import React, {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

// Define the type for your data
type DataType = {
  headerData: string;
  setHeader: React.Dispatch<React.SetStateAction<string>>;
  userData: any;
  setUserData: React.Dispatch<React.SetStateAction<string>>;
  permissionData: any;
  setPermissionData: React.Dispatch<React.SetStateAction<string>>;
  sessionExpired: boolean;
  setSessionExpired: any;
  sessionExpireAlert: boolean;
  setSessionExpireAlert: any;
  sessionExpireTime: number;
  setSessionExpireTime: any;
  configData: any;
  setConfigData: any;
  currentRole: "INVESTOR" | "SELLER" | "PROJECT_REVIEWER" | "SALES_PARTNER";
  setCurrentRole: any;
  setTaskIdInComments: any;
  taskIdInComments: string;
  setupGuideData: any;
  setSetupGuideData: any;
  upload: any;
  setUpload: any;
  currentOrg: any;
  setCurrentOrg: any;
  userOrgs: any[];
  setUserOrgs: React.Dispatch<React.SetStateAction<any[]>>;
  projectPermission: any;
  setProjectPermission: any;
  projectPermissionLoading: any;
  setProjectPermissionLoading: any;
};

// Create a new context
const DataContext = createContext<DataType | undefined>(undefined);

// Custom hook to use the context
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
interface DataProviderProps {
  children: ReactNode; // Define children prop
}

// Data provider component
export const UserProvider: React.FC<DataProviderProps> = ({ children }) => {
  // Define your state here

  const [userData, setUserData] = useState("");
  const [headerData, setHeader] = useState("");
  const [currentRole, setCurrentRole] = useState<any>("");
  const [currentOrg, setCurrentOrg] = useState<any>(null);
  const [projectPermission, setProjectPermission] = useState<any>(null);
  const [projectPermissionLoading, setProjectPermissionLoading] =
    useState(false);

  const [permissionData, setPermissionData] = useState("");
  const [upload, setUpload] = useState<any>({});
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionExpireAlert, setSessionExpireAlert] = useState(false);
  const [sessionExpireTime, setSessionExpireTime] = useState(0);
  const [configData, setConfigData] = useState("");
  const [userOrgs, setUserOrgs] = useState<any[]>([]);
  const [setupGuideData, setSetupGuideData] = useState({
    data: {},
    refetch: () => {},
  });

  const [taskIdInComments, setTaskIdInComments] = useState("");

  return (
    <DataContext.Provider
      value={{
        userData,
        setUserData,
        permissionData,
        headerData,
        setHeader,
        setPermissionData,
        sessionExpired,
        setSessionExpired,
        sessionExpireAlert,
        setSessionExpireAlert,
        sessionExpireTime,
        setSessionExpireTime,
        configData,
        setConfigData,
        currentRole,
        setCurrentRole,
        taskIdInComments,
        setTaskIdInComments,
        setupGuideData,
        setSetupGuideData,
        upload,
        setUpload,
        currentOrg,
        setCurrentOrg,
        userOrgs,
        setUserOrgs,
        projectPermission,
        setProjectPermission,
        projectPermissionLoading,
        setProjectPermissionLoading,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
